import {Component, h} from "preact";
import styles from './style.module.scss';
import ListHeader from "../../components/list-header";
import ListFilter from "../../components/list-filter";
import ListGrid from "../../components/list-grid";
import {customerService} from "../../services/customer-service";
import {Like} from "../../models/customer";
import actions from "../../store/actions";
import {connect} from "redux-zero/preact";
import {filterService} from "../../services/filter-service";
import {FilterMap, ProductFilter} from "../../models/filter";
import {Dimension, NY_Tracker} from "../../services/tracking-service";
import Interstitial from "../../components/interstitial";
import {productService} from "../../services/product-service";
import {Product, Variant} from "../../models/product";
import {QueryState} from "../../models/query";
import {Collection} from "../../models/collection";
import Editorial from "../../components/editorial";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";

interface Props {
  setLikes(likes: Like[], products?: Product[]);

  toggleLike(variant: Variant, newLikeState: boolean, dimension: string);

  initStore(filterMap: FilterMap);

  updateStore(filterMap: FilterMap);

  toggleFilter(filter: ProductFilter)

  isInterstitialOpen: boolean;
  url: string;
  filters: FilterMap;
  products: QueryState;
  collections: Collection[];
  initialized: boolean;
  isMobile: boolean;
  likes: Like[];
}

const mapToProps = ({isInterstitialOpen, filters, products, initialized, likes}) => (
  {isInterstitialOpen, filters, products, initialized, likes});

export class Home extends Component<Props, any> {

  async componentDidMount(): Promise<void> {
    window.addEventListener('ny-products-client', this._handleCustomEvents.bind(this))
    const filterMap = await filterService.initFilterMap();
    this.props.initStore(filterMap);
    NY_Tracker.trackPage(window.location.pathname + '?' + filterService.createUrlSearchParams(filterMap), document.title);

    customerService.subscribeForCustomer(async (data) => {
      if (!customerService.isLoggedIn) {
        this.props.setLikes([]);
        if (this.props.filters.likes[0]?.selected) {
          this.props.toggleFilter(this.props.filters.likes[0]);
        }
      }
      if (data) {
        const {userLikes, productItems} = await customerService.loadFavouriteProducts(filterMap.country);
        this.props.setLikes(userLikes, productItems).then(() => customerService.likeCachedVariant());
      }
    });
  }

  async componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any) {
    if (this.props.url !== nextProps.url) {
      const filterMap = await filterService.initFilterMap();
      this.props.updateStore(filterMap);
      NY_Tracker.trackPage(window.location.pathname + '?' + filterService.createUrlSearchParams(filterMap), document.title);
    }
  }

  _handleCustomEvents(e: CustomEvent) {
    if (e.detail.route === 'FAVORITES') {
      if (!this.props.filters.likes[0].selected) {
        this.props.toggleFilter(this.props.filters.likes[0])
      }
    }
  }

  render() {
    if (this.props.initialized && this.props.isMobile && this.props.filters.editorials.find(c => c.selected)) {
      return (
        <div>
          {this.props.isInterstitialOpen ? <Interstitial/> : null}
          <ListHeader/>
          <Editorial/>
        </div>
      )
    } else if (this.props.initialized && this.props.filters.editorials.find(c => c.selected)) {
      return (
        <div>
          {this.props.isInterstitialOpen ? <Interstitial/> : null}
          <ListHeader/>
          <div class={styles['list-content']}>
            <ListFilter/>
            <Editorial/>
          </div>
        </div>
      )
    } else if (this.props.initialized) {
      return (
        <div>
          {this.props.isInterstitialOpen ? <Interstitial/> : null}
          <ListHeader/>
          <div class={styles['list-content']}>
            <ListFilter/>
            <ListGrid/>
          </div>
        </div>
      )
    }
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(Home))